<script setup>
import { watch, ref } from 'vue'
import { RouterView, useRoute, useRouter } from 'vue-router'

import NavBar from '@/components/Generics/NavBar.vue'
import SideBar from '@/components/Generics/SideBar.vue'
import ContentHeader from '@/components/Generics/ContentHeader.vue'
import Footer from '@/components/Generics/Footer.vue'

import { usePageNumberStore } from '@/services/store.js'
import ConfigurationProvider from '@/provider/configuration.js'

const pageNumberStore = usePageNumberStore()

const route = useRoute()
const router = useRouter()
const pageTitle = ref('')

const updatePageTitle = (pagename) => {
  pageTitle.value = route.meta.title
  if (pagename) {
    pageTitle.value = pagename
  }
}

watch(
  () => route.name,
  (newRoute, oldRoute) => {
    if (oldRoute && oldRoute.indexOf(newRoute) < 0) {
      pageNumberStore.setPageNumber(1, route.name)
    }
  }
)

watch(route, (newRoute) => {
  const defaultHomePageRoute =  ConfigurationProvider.getConfig()?.app?.default_homepage_route

  const page403 = 'admin/error_403'
  const page404 = 'admin/error_404'

  if ([page403, page404].includes(newRoute.name)) {
    return
  }

  if ((newRoute.fullPath === '/admin' || newRoute.fullPath === '/admin/' ) && defaultHomePageRoute) {
    router.replace({ path: defaultHomePageRoute })
  } else if (newRoute?.meta?.permissions?.canView === false && router.hasRoute(page403)) {
    router.replace({ name: page403})
  } else if (!router.hasRoute(newRoute.name) && router.hasRoute(page404)) {
    router.replace({ name: page404 })
  }
})

function toggleSidebar() {
  document.body.classList.toggle('sidebar-collapse')
  document.body.classList.toggle('sidebar-open')
}

</script>

<template>

  <nav-bar @toggle-sidebar="toggleSidebar"></nav-bar>

  <div class="app-wrapper">

    <SideBar @toggle-sidebar="toggleSidebar"></SideBar>

    <main class="app-main">

      <content-header :updatePageTitle="updatePageTitle">{{ pageTitle }}</content-header>

      <div class="app-content">
        <div class="container-fluid pb-4">

          <RouterView :updatePageTitle="updatePageTitle"></RouterView>

        </div>
      </div>

    </main>

  </div>
  <Footer></Footer>
</template>
